import EditIcon from "@mui/icons-material/Edit";
import {
  Avatar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import Loader from "../../../components/Loader";
import AddSheduleMenu from "../../../components/MenuDropDown/SheduleAddMenu";
import SheduleEditMenu from "../../../components/MenuDropDown/SheduleEditMenu";
import SnackbarAlert from "../../../components/SnackBar";
import MainData from "../../../dumyData/ShedulingData.json";
import { teamSchedule } from "../../../services/Team";
import { getCurrentWeek } from "../../../utils";
import AddEditShiftDialog from "./AddEditShiftDialog";
import appcolors from "../../../constants/Colors";

const tableContainer = {
  "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
    backgroundColor: "#F5F1F1",
    "&:first-child": {
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      border: "3px solid #ffffff",
      borderBottom: "none",
    },
    "&:nth-child(2)": {
      borderTopLeftRadius: "12px",
      borderBottomLeftRadius: "12px",
    },
    "&:last-child": {
      borderTopRightRadius: "12px",
      borderBottomRightRadius: "12px",
    },
  },

  "& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
    // backgroundColor: "#FDEEE6",
    fontSize: "0.75rem",
    border: "3px solid #ffffff",
    borderBottom: "none",
    borderRadius: "12px",
    padding: "0px",

    "&:first-child": {
      borderRadius: "0px",
      backgroundColor: "#F5F1F1",
      borderTop: "3px solid #F5F1F1",
      borderBottom: "none",
      padding: "10px 5px",
      // paddingBottom:"20px"
    },
  },

  "& .MuiTableCell-root": {
    padding: "16px 8px",
  },
};

function Sheduling() {
  const openDialog = useRef(null);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [teamScheduleData, setTeamScheduleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    handlefetchTeamShedule();
    setWeekDates(getCurrentWeek());
  }, [selectedBranch]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };
  getCurrentWeek();
  useEffect(() => {
    const currentWeek = Array.from({ length: 7 }, (_, index) =>
      moment().startOf("week").add(index, "days")
    );
    setWeekDates(currentWeek);
  }, []);
  const handlefetchTeamShedule = async () => {
    try {
      setIsLoading(true);
      const responce = await teamSchedule(selectedBranch[0]);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        let data = responce.data.data;
        setTeamScheduleData(data);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
      console.log(responce?.data?.data, "reaponsereaponsereaponsereaponse");
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log(error, "errorerrorerrorerror");
    }
  };

  const handleSelectOption = (type) => {
    if (type === "editDay") {
      openDialog.current.isVisible({ type: "edit", data: null });
    }
  };

  // Render right part on header
  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <AddSheduleMenu />
      </Stack>
    );
  };

  return (
    <>
      <AppContainer
        primaryHeading={"Scheduled shifts"}
        secondaryHeading={"Please set your team weekly time schedule"}
        // headProps={renderRightPart()}
      >
        {teamScheduleData?.length > 0 ? (
          <TableContainer sx={{ ...tableContainer, borderSpacing: "0 10px" }}>
            <Table>
              <TableHead>
                <TableRow sx={{ alignContent: "flex-start" }}>
                  <TableCell sx={{ borderTopLeftRadius: "10px" }}>
                    Team member
                  </TableCell>
                  {weekDates.map((date, index) => (
                    <TableCell key={index} align="center">
                      {moment(date).format("ddd, DD MMM")}
                      <br />
                      <span style={{ fontSize: "0.75rem" }}>18h</span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {teamScheduleData?.map((member, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ width: "20%" }}>
                      <Stack gap={1} alignItems={"center"}>
                        <Stack direction={"row"} alignItems={"center"} gap={1}>
                          <Avatar
                            src={member?.image}
                            sx={{
                              height: 35,
                              width: 35,
                              boxShadow: "2px 2px 10px 0px #00000040",
                            }}
                          />
                        </Stack>

                        {/* <Box> */}
                        <Typography variant="body2">{member.name}</Typography>
                        {/* <Stack
                          direction={"row"}
                          alignItems={"center"}
                          gap={1}
                        ></Stack> */}
                        {/* </Box> */}
                      </Stack>
                    </TableCell>
                    {member?.shift?.map((shift, shiftIndex) => (
                      <TableCell
                        key={shiftIndex}
                        sx={{
                          width: `${80 / weekDates.length}%`,
                          position: "relative",
                          alignContent: "flex-start",
                        }}
                      >
                        <SheduleEditMenu
                          width={80 / weekDates.length}
                          value={shift}
                          handleSelectOption={handleSelectOption}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography
            variant="h1"
            fontSize={23}
            textAlign={"center"}
            color={appcolors.black}
            mt={20}
            mb={20}
          >
            No Team Data Found!
          </Typography>
        )}
      </AppContainer>

      {/* Shedule dialog */}
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Loader isLoading={isLoading} />
      <AddEditShiftDialog ref={openDialog} />
    </>
  );
}

export default Sheduling;
